export default "__VITE_ASSET__Dr4JUuge__"